/*
 * File: d:\projects\AutoFiFront\src\Content\TextBox\TextBox.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday April 17th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday April 17th 2023 2:25:42 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { ReactNode } from 'react';
import translator from 'MultiLanguage/TranslationWrapper';
import styles from 'Content/TextBox/TextBox.module.css';

type TextBoxProps = {
    title: string,
    text: string,
    icon: ReactNode
};

function TextBox(props: TextBoxProps) {
    return (
        <div className={`${styles.boxHolder}`}>
            <div className={`${styles.engagementIcon}`}>
                {props.icon}
            </div>
            <h3 className={`${styles.engagementTitle}`}>
                {translator.decode(`TextBox.${props.title}`)}
            </h3>
            <p className={`${styles.engagementText}`}>
                {translator.decode(`TextBox.${props.text}`)}
            </p>
        </div>
    );
};

export default TextBox;
